<template>
    <div class="block mb-6">
        <div
            v-if="!!$slots['label']"
            class="flex items-center mb-1"
        >
            <div class="flex items-center flex-grow">
                <label class="text-xs font-semibold tracking-wide uppercase text-grey-darker">
                    <slot name="label" />

                    <span
                        v-if="isRequired"
                        class="leading-none text-red"
                        v-text="requiredText"
                    />
                </label>
            </div>

            <base-tooltip
                v-if="!!$slots['help']"
                :close-after="5000"
                class="w-4 h-4"
            >
                <base-svg
                    slot="trigger"
                    name="icon-help-circle"
                    class="w-full h-full"
                />

                <slot
                    slot="tooltip"
                    name="help"
                />
            </base-tooltip>
        </div>

        <slot />

        <div
            v-if="sid && $validator.has(validatorName, sid) || errorText"
            v-html="$validator.first(validatorName, sid) || errorText"
            class="mt-1 text-xs leading-tight text-red"
            :class="errorClass"
        />

        <div
            v-else-if="!!$slots['hint']"
            class="mt-1 text-xs leading-tight text-grey-darker"
        >
            <slot name="hint" />
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            sid: {
                type: String,
                default: null
            },
            name: {
                type: String,
                required: true
            },
            validatorName: {
                type: String,
                required: false,
                default () {
                    return this.name.replace(/\[/g, '.').replace(/\]/g, '')
                }
            },
            isRequired: {
                type: Boolean,
                default: false
            },
            requiredText: {
                type: String,
                default: '•'
            },
            errorText: {
                type: String,
                required: false,
                default () {
                    return ''
                }
            },
            errorClass: {
                type: String,
                required: false,
                default () {
                    return ''
                }
            }
        }
    }
</script>
